import React from 'react'
import FormMultiImages from 'components/forms/image/FormMultiImages'
import { updateObject } from 'helpers/objectHelpers'
import { initialImageCarousel } from 'helpers/initialState'
import CustomTabs from 'components/Tabs/CustomTabs'
import Accordion from 'components/accordions/Accordion'
import withDevicesForm from 'hocs/extends/withDevicesForm'
import FormCarouselSettings from 'components/forms/image/FormCarouselSettings'
import StylesSwitcher from 'components/Canvas/builder/components/panel/StylesSwitcher'
import { refElements } from 'components/Canvas/renderer/utils/elementUtils'

const DevicesFormCarouselSettings = withDevicesForm(FormCarouselSettings)

const FormImageCarousel = ({
  value = initialImageCarousel,
  onChange,
}) => {
  const {
    defaultContent: {
      images = [],
    },
    defaultSettings = {},
    deviceSettings = {},
    defaultStyles = {},
    deviceStyles = {},
  } = value
  const handleUpdate = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  const updateDefaultContent = (val, key) => {
    return handleUpdate(
      updateObject(
        value.defaultContent, { [key]: val }
      ),
      'defaultContent',
    )
  }
  return (
    <FormMultiImages
      value={images}
      onChange={(val) => updateDefaultContent(val, 'images')}
    />
  )
}

FormImageCarousel.propTypes = {}
FormImageCarousel.defaultProps = {}

export default FormImageCarousel



// WEBPACK FOOTER //
// ./src/components/forms/image/FormImageCarousel.js